import {injectable} from "inversify";
import {Negotiation} from "@/modules/diplomacy/entity";
import {Component} from "@vue/runtime-core";

export type NegotiationComponent = {
  class: new (...args: any[]) => Negotiation,
  component: Component,
}

@injectable()
export class NegotiationComponentManager {
  private items: NegotiationComponent[] = [];

  public addItem(item: NegotiationComponent) {
    this.items.push(item);
  }

  public getComponent(negotiation: Negotiation): Component {
    const item = this.items.find(item => negotiation instanceof item.class);

    if (!item) {
      throw 'There is not matching component for negotiation type';
    }

    return item.component;
  }
}